import { clientsRetrieveOptions } from '@crm/api'
import { useLocales } from '@shared/locales'
import { useQuery } from '@tanstack/react-query'
import { Card, Descriptions, Divider, Flex, Spin } from 'antd'
import { useParams } from 'react-router-dom'

export const ClientCard = () => {
  const { t } = useLocales()
  const { id } = useParams()

  const { data: client, isLoading } = useQuery({
    ...clientsRetrieveOptions({ path: { id: Number(id) } }),
    enabled: !!id
  })

  const items = [
    { label: t('contacts.status'), children: client?.status?.name },
    {
      label: t('identification_number'),
      children: client?.identification_number
    },
    {
      label: t('contacts.first_name'),
      children:
        [
          client?.primary_contact?.first_name,
          client?.primary_contact?.last_name
        ]
          .filter(Boolean)
          .join(' ') || null
    },
    { label: t('contacts.email'), children: client?.primary_contact?.email },
    {
      label: t('contacts.phone_number'),
      children: client?.primary_contact?.phone_number
        ? String(client.primary_contact.phone_number)
        : null
    },
    {
      label: t('created_by'),
      children:
        [client?.created_by?.first_name, client?.created_by?.last_name]
          .filter(Boolean)
          .join(' ') || null
    }
  ].filter(({ children }) => children)

  return (
    <Spin spinning={isLoading}>
      <Card variant="borderless">
        <Flex vertical gap={8}>
          <strong>{client?.name}</strong>
        </Flex>

        {items.length > 0 && (
          <>
            <Divider />
            <Descriptions
              size="small"
              bordered
              colon={false}
              column={1}
              items={items}
            />
          </>
        )}
      </Card>
    </Spin>
  )
}
